import React, { Fragment } from 'react';
import styled from 'styled-components';
import InsurerPhone from '../InsurerPhone';
import { ACCOUNT_CALL_INSURANCE_BENEFITS } from '../../../../../../core/analytics/events';
import { getInsuranceCarrierCardDisplayProperties } from '../../../../../../core/util/insurance';
import { safeGet } from '../../../../../../core/util/object';
import { fontSize } from '../../../../../../constants/text';
import { smallerThanOrEqualTo } from '../../../../../../core/util/styledComponents';

const Span = styled.span.withConfig({ componentId: 'sc-hs63yv-0' })`
  z-index: 1400;
  letter-spacing: 0.25px;
  line-height: 21px;
`;

const FirstParagraph = styled.p.withConfig({ componentId: 'sc-hs63yv-1' })`
  margin-top: 0;
  ${smallerThanOrEqualTo.sm`
    margin-top: 10px;
  `};
`;

const Subtext = styled.div.withConfig({ componentId: 'sc-hs63yv-2' })`
  font-size: ${fontSize.small};
`;

type Props = {
  insuranceProfile?: any;
};

const ServiceComingSoonSubtext = (props: Props) => {
  const { insuranceProfile } = props;
  const insuranceCarrierDisplayProperties = getInsuranceCarrierCardDisplayProperties(
    insuranceProfile.insurer_code
  );
  const benefitsPhone = safeGet(insuranceCarrierDisplayProperties)('phoneNumber');

  return (
    <Span>
      <FirstParagraph>We're adding more price breakdowns all the time.</FirstParagraph>

      <Subtext>
        Call your insurer
        {benefitsPhone && (
          <>
            {' '}
            at{' '}
            <InsurerPhone
              insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
              insuranceCarrierName={insuranceProfile.insurer_name}
              insurerCode={insuranceProfile.insurer_code}
              insurerPhone={benefitsPhone}
              insurerType={insuranceProfile.insurer_type}
              trackingCode={ACCOUNT_CALL_INSURANCE_BENEFITS}
            />
          </>
        )}
        <br />
        if you have any questions.
      </Subtext>
    </Span>
  );
};

export default ServiceComingSoonSubtext;
